import { render, staticRenderFns } from "./u-button.vue?vue&type=template&id=3bf2dba7&scoped=true&"
import script from "./u-button.vue?vue&type=script&lang=js&"
export * from "./u-button.vue?vue&type=script&lang=js&"
import style0 from "./u-button.vue?vue&type=style&index=0&id=3bf2dba7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf2dba7",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-button/u-button.vue"
export default component.exports